/** Einheitliche Support-Telefonnummer für Impressum, AGB, Datenschutz, AVV */
export const SUPPORT_PHONE_DISPLAY = '+49 1515 7705716';
export const SUPPORT_PHONE_TEL = '+4915157705716';

/** Einheitliche Anbieterbezeichnung für Impressum, AGB, Datenschutz, AVV (Einzelunternehmen) */
export const LEGAL_OPERATOR_NAME = 'Synergic Systems – Jannick Müller';
export const LEGAL_RESPONSIBLE_PERSON = 'Jannick Müller, handelnd unter Synergic Systems';
export const LEGAL_ADDRESS_STREET = 'Maria-Hilf-Straße 11';
export const LEGAL_ADDRESS_CITY = '50677 Köln';
export const LEGAL_ADDRESS_COUNTRY = 'Deutschland';

/** Zuständige Datenschutzaufsichtsbehörde für ein privates Unternehmen mit Sitz in Köln (NRW) */
export const DATA_PROTECTION_AUTHORITY_NAME = 'Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)';
export const DATA_PROTECTION_AUTHORITY_ADDRESS = 'Kavalleriestraße 2–4, 40213 Düsseldorf';
export const DATA_PROTECTION_AUTHORITY_URL = 'https://www.ldi.nrw.de';
